
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 1000 1000","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M510.838 300.059c-25.5-27.5-64.616 32.953-86.5 81.5-19.09 42.349-33.287 116.457-21 114 10-2 69.994-149.5 90.5-149.5 36.5 0 72.5 176.5 24.5 394.5-27.965 127.008-67.88 202.788-117.5 198.5-40.5-3.5-66.663-53.105-66.946-117.059-.554-125.441 72.834-292.768 183.839-409.694 29.457-31.029 69.643-55.158 97.107-84.248"}}),_c('path',{staticClass:"st0",attrs:{"d":"M685.5 89.5C638.963 201.965 599 383 592 464c0 0 6.275-26.509 7-29 16-55 64-131 91.5-117.5 38.19 18.748-66.5 216.5-102 205-23.467-7.602 14-125 102-181 23.166-14.742 38.5-17.5 72-43M528.222 689.5H835.5v-510"}}),_c('path',{staticClass:"st0",attrs:{"d":"M668.081 135.5H243.5v511"}})])
          )
        }
      }
    